(() => {
  if (window.qfPortalMenuInitialized) return;
  window.qfPortalMenuInitialized = true;

  const getParts = (root) => ({
    toggle: root.querySelector('[data-qf-menu-toggle]'),
    panel: root.querySelector('[data-qf-menu-panel]')
  });

  const closeMenu = (root, restoreFocus = false) => {
    const { toggle, panel } = getParts(root);
    if (!toggle || !panel || panel.hidden) return;
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle.focus();
  };

  const closeOtherMenus = (activeRoot) => {
    document.querySelectorAll('[data-qf-menu]').forEach((root) => {
      if (root !== activeRoot) closeMenu(root);
    });
  };

  const openMenu = (root) => {
    const { toggle, panel } = getParts(root);
    if (!toggle || !panel) return;
    closeOtherMenus(root);
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    const firstControl = panel.querySelector('button, a[href]');
    if (firstControl) firstControl.focus();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-qf-menu-toggle]');
    if (toggle) {
      const root = toggle.closest('[data-qf-menu]');
      const panel = root && root.querySelector('[data-qf-menu-panel]');
      if (!root || !panel) return;
      if (panel.hidden) openMenu(root);
      else closeMenu(root, true);
      return;
    }

    const close = event.target.closest('[data-qf-menu-close]');
    if (close) {
      const root = close.closest('[data-qf-menu]');
      if (root) closeMenu(root, true);
      return;
    }

    document.querySelectorAll('[data-qf-menu]').forEach((root) => {
      const panel = root.querySelector('[data-qf-menu-panel]');
      if (!panel || panel.hidden) return;
      if (!root.contains(event.target)) closeMenu(root);
      else if (event.target.closest('[data-qf-menu-panel] a[href]')) closeMenu(root);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-qf-menu]').forEach((root) => {
      const panel = root.querySelector('[data-qf-menu-panel]');
      if (panel && !panel.hidden) closeMenu(root, true);
    });
  });
})();
